import t from '../actions/actionTypes'

const defaultState = {
	list: [],
	adding: [],
	removing: [],
}

function updateList(state, action) {
	const newState = {...state}
	const list = action.entities.map(function(item) {
		return item.data.entityUID
	})
	newState.list = list
	if (action.entityUID) {
		let index = newState.adding.indexOf(action.entityUID)
		if (index !== -1) {
			const newAdding = [...newState.adding.splice(0, index), ...newState.adding.splice(index + 1, newState.adding.length)]
			newState.adding = newAdding
		} else {
			index = newState.removing.indexOf(action.entityUID)
			if (index !== -1) {
				const newRemoving = [...newState.removing.splice(0, index), ...newState.removing.splice(index + 1, newState.removing.length)]
				newState.removing = newRemoving
			}
		}
	}
	return newState
}

function updateListFromPurchase(state, action) {
	const newState = {...state}
	const index = newState.adding.indexOf(action.entityUID)
	const newAdding = [...newState.adding.splice(0, index), ...newState.adding.splice(index + 1, newState.adding.length)]
	newState.adding = newAdding
	return newState
}

function updateCartItemStatus(state, action) {
	const newState = {...state}
	if (action.onCart) {
		const newRemoving = [...state.removing, action.entityUID]
		newState.removing = newRemoving
	} else {
		const newAdding = [...state.adding, action.entityUID]
		newState.adding = newAdding
	}
	return newState
}

function handleCartFailed(state, action) {
	const newState = {...state}
	let index = state.removing.indexOf(action.entityUID)
	if (index !== -1) {
		const newRemoving = [...newState.removing.splice(0, index), ...newState.removing.splice(index + 1, newState.removing.length)]
		newState.removing = newRemoving
	} else {
		index = state.adding.indexOf(action.entityUID)
		if (index !== -1) {
			const newAdding = [...newState.adding.splice(0, index), ...newState.adding.splice(index + 1, newState.adding.length)]
			newState.adding = newAdding
		}
	}
	return newState

}

const cartReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.CART_DATA_FETCHED:
		case t.CART_ITEM_ADDED:
		case t.CART_ITEM_REMOVED:
			return updateList(state, action)
		case t.CART_BUY_PRODUCT_SUCCESS:
			return updateListFromPurchase(state, action)
		case t.CART_TOGGLE:
		case t.CART_DOWNLOADING:
			return updateCartItemStatus(state, action)
		case t.CART_ITEM_FAILED:
			return handleCartFailed(state, action)
		default:
			return state
	}
}

export default cartReducer
